import { useSelector } from "react-redux";
import { CellProps } from "react-table";
import TextCell from "src/components/tables/cells/TextCell";
import Toggle from "src/components/toggles/Toggle";
import { hasEditAccess } from "src/redux/selectors/app";
import ActionsCell from "./ActionsCell";
import { ServiceType } from "./services-types";

const useServicesTableColumns = ({
  onDelete,
  handleServiceStatusChange,
}: {
  onDelete: (id: number) => void;
  handleServiceStatusChange: (serviceId: number, status: boolean) => void;
}) => {
  const hasEditPermission = useSelector(hasEditAccess);

  return [
    {
      Header: "Name",
      accessor: "name",
      className: "min-w-[180px]",
      Cell: TextCell,
    },
    {
      Header: "Price (₹)",
      accessor: "price",
      className: "min-w-[150px]",
      Cell: ({ value, row }: CellProps<ServiceType>) => {
        return <TextCell value={value ?? 0} />;
      },
    },
    {
      Header: "Duration",
      accessor: "duration",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Reward Points",
      accessor: "reward",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Required Items",
      accessor: "requiredItems",
      className: "min-w-[150px]",
      Cell: ({ row: { original } }: CellProps<ServiceType>) => (
        <TextCell value={original.products.length} />
      ),
    },
    {
      Header: "Status",
      accessor: "status",
      className: "min-w-[150px]",
      Cell: ({ value, row }: CellProps<ServiceType>) => {
        return (
          <div className="flex justify-center">
            <Toggle
              checked={value}
              onToggle={(value) =>
                handleServiceStatusChange(row.original.id, value)
              }
              showToggleStatus
              disabled={!hasEditPermission}
              tooltip={
                hasEditPermission ? "" : "You don't have permission to edit."
              }
            />
          </div>
        );
      },
    },
    {
      Header: "Actions",
      accessor: "id",
      className: "min-w-[200px]",
      Cell: ({ value }: CellProps<ServiceType>) => (
        <ActionsCell value={value} onDelete={() => onDelete(value)} />
      ),
    },
  ];
};

export default useServicesTableColumns;
